import React, { useState, useRef, useLayoutEffect, useCallback } from "react";
import ContextMenuWindow from "../ContextMenuWindow/ContextMenuWindow";
import { useLang } from "../../hooks/useLang";
export default function ContextMenu(props) {
    const [show, setShow] = useState(false);
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0, origin: { x: 0, y: 0 } });
    const [contextMenuSize, setContextMenuSize] = useState({ width: 0, height: 0 });
    const windowContainerRef = useRef(null);
    const lang = useLang();
    useLayoutEffect(() => {
        if (windowContainerRef.current && show) {
            setContextMenuSize({
                width: windowContainerRef.current.offsetWidth,
                height: windowContainerRef.current.offsetHeight
            });
        }
    }, [show]);
    const onContextMenuKeyDown = useCallback((e) => {
        if (e.key === 'Enter' || e.code === 'Space') {
            e.preventDefault();
            e.target.dispatchEvent(new MouseEvent('contextmenu', {
                bubbles: true,
                cancelable: true,
                clientX: e.target.offsetLeft - document.documentElement.scrollLeft,
                clientY: e.target.offsetTop - document.documentElement.scrollTop
            }));
        }
    }, []);
    const onContextMenu = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        openMenu({ x: e.clientX, y: e.clientY });
    }, []);
    function calculatePosition(position) {
        var processedPosition = Object.assign(Object.assign({}, position), { origin: { x: 0, y: 0 } });
        if (processedPosition.x + contextMenuSize.width > window.innerWidth) {
            processedPosition.x = processedPosition.x - contextMenuSize.width;
            processedPosition.origin.x = 100;
        }
        else {
            processedPosition.origin.x = 0;
        }
        if (processedPosition.y + contextMenuSize.height > window.innerHeight) {
            processedPosition.y = processedPosition.y - contextMenuSize.height;
            processedPosition.origin.y = 100;
        }
        else {
            processedPosition.origin.y = 0;
        }
        return Object.assign({}, processedPosition);
    }
    function openMenu(position) {
        if (props.onOpen)
            props.onOpen();
        setMousePosition(calculatePosition(position));
        setShow(true);
    }
    const onTransitionEnd = useCallback(() => {
        setShow(false);
    }, []);
    return (React.createElement("div", { "aria-haspopup": true, tabIndex: 0, "aria-label": lang['aria-label'], onKeyDown: onContextMenuKeyDown, onContextMenu: onContextMenu },
        props.children,
        show ? React.createElement(ContextMenuWindow, Object.assign({ position: mousePosition, onTransitionEnd: onTransitionEnd, containerRef: windowContainerRef }, props)) : null));
}
